import {GetStaticPaths, GetStaticProps} from 'next';

import {Layout} from 'src/components';
import {SEOProps} from 'src/components/layout/SEO';
import {regionalConfigsArr} from 'src/config/regions';
import {ResetPasswordSend} from 'src/features/auth/components';
import {PageParams} from 'src/types';

export const getStaticPaths: GetStaticPaths = async () => {
  const paths: {params: PageParams}[] = [];

  for (const config of regionalConfigsArr) {
    const {regionCode, locales} = config;

    for (const locale of locales) {
      paths.push({params: {region: regionCode, locale}});
    }
  }

  return {paths, fallback: false};
};

export const getStaticProps: GetStaticProps<PageParams, PageParams> = async (
  ctx
) => {
  const {params} = ctx;

  if (!params) {
    throw new Error('Could not find params for ');
  }

  const {region, locale} = params;

  return {
    props: {
      region,
      locale,
    },
  };
};

const ResetPasswordSendPage: React.FC<React.PropsWithChildren<PageParams>> = (
  props
) => {
  const {region, locale} = props;

  const seo: SEOProps = {
    title: 'Reset Password', // TODO localize this string
    description: '',
    noIndex: true,
    includeInRegions: ['all'],
    slug: 'reset-password-send',
    slugPrefix: '',
  };

  return (
    <Layout seo={seo} pageContext={{region, locale}} pure>
      <ResetPasswordSend />
    </Layout>
  );
};

export default ResetPasswordSendPage;
